
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"17.647","height":"17.653"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Component 101"}},[_c('g',{attrs:{"data-name":"Group 656"}},[_c('g',{attrs:{"data-name":"Path 749"}},[_c('path',{attrs:{"data-name":"Path 751","d":"M17.647 8.834a.951.951 0 01-.281.675.93.93 0 01-.675.287h-6.9v6.9a.97.97 0 01-.963.956.951.951 0 01-.675-.281.931.931 0 01-.287-.675v-6.9h-6.9a.964.964 0 01-.682-1.638 1 1 0 01.682-.287h6.9v-6.9a.938.938 0 01.287-.688.951.951 0 01.675-.281.973.973 0 01.963.969v6.9h6.9a.975.975 0 01.956.963z","fill":"#a8dded"}})])])])])
          )
        }
      }
    